import Vue from "vue";
import Vuex from "vuex";
import portalStats from "./modules/portal-stats";
import subscriber from "./modules/subscriber";
import auth from "./modules/auth";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    subscriber,
    portalStats,
    auth
  },
  plugins: [vuexLocal.plugin]
});
